'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["orientation"],
  _excluded2 = ["InnerWrapper", "orientation", "Primary", "primaryContent", "primaryClassName", "primaryWidth", "reverseOrder", "Secondary", "secondaryContent", "secondaryClassName", "secondaryWidth"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getComponentPropType } from '../utils/propTypes/componentProp';
import UIFlex from '../layout/UIFlex';
import UIBox from '../layout/UIBox';
import { BASE_SPACING_X, BASE_SPACING_Y } from 'HubStyleTokens/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Outer = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest));
}).withConfig({
  displayName: "UISplitLayout__Outer",
  componentId: "si645g-0"
})(["padding-left:", ";width:100%;"], BASE_SPACING_X);
const Inner = styled(UIFlex).withConfig({
  displayName: "UISplitLayout__Inner",
  componentId: "si645g-1"
})(["margin-left:-", ";margin-top:-", ";"], BASE_SPACING_X, BASE_SPACING_Y);
const getSlotPadding = `
  padding-left: ${BASE_SPACING_X};
  padding-top: ${BASE_SPACING_Y};
`;
const PrimarySlot = styled(UIBox).withConfig({
  displayName: "UISplitLayout__PrimarySlot",
  componentId: "si645g-2"
})(["", ";"], getSlotPadding);
const SecondarySlot = styled(UIBox).withConfig({
  displayName: "UISplitLayout__SecondarySlot",
  componentId: "si645g-3"
})(["", ";"], getSlotPadding);
export default function UISplitLayout(props) {
  const {
      InnerWrapper,
      orientation,
      Primary,
      primaryContent,
      primaryClassName,
      primaryWidth,
      reverseOrder,
      Secondary,
      secondaryContent,
      secondaryClassName,
      secondaryWidth
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded2);
  const computedDirection = orientation === 'horizontal' ? 'row' : 'column';
  return /*#__PURE__*/_jsx(Outer, Object.assign({}, rest, {
    orientation: orientation,
    children: /*#__PURE__*/_jsxs(InnerWrapper, {
      direction: computedDirection,
      justify: "between",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsx(Primary, {
        className: primaryClassName,
        basis: primaryWidth,
        orientation: orientation,
        order: reverseOrder ? 1 : 0,
        children: primaryContent
      }), /*#__PURE__*/_jsx(Secondary, {
        basis: secondaryWidth,
        className: secondaryClassName,
        orientation: orientation,
        children: secondaryContent
      })]
    })
  }));
}
UISplitLayout.propTypes = {
  InnerWrapper: getComponentPropType(UIFlex),
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  Primary: getComponentPropType(UIBox),
  primaryContent: PropTypes.node.isRequired,
  primaryClassName: PropTypes.string,
  primaryWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  reverseOrder: PropTypes.bool.isRequired,
  Secondary: getComponentPropType(UIBox),
  secondaryContent: PropTypes.node,
  secondaryClassName: PropTypes.string,
  secondaryWidth: PropTypes.number,
  width: PropTypes.number
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UISplitLayout.defaultProps = {
  InnerWrapper: Inner,
  Primary: PrimarySlot,
  Secondary: SecondarySlot,
  orientation: 'horizontal',
  reverseOrder: false
};
UISplitLayout.displayName = 'UISplitLayout';